const possibleCompanyCSVFieldTypes = {
    "ACTIVITY":"activity"
}

export {
    possibleCompanyCSVFieldTypes
}